import type { RouteObject } from 'react-router';
import { ConnectionPage } from './ConnectionPage';

/** Detail routes (paths without a leading slash). */
export const INTEGRATIONS_ROUTES: RouteObject[] = [{ path: 'settings/registries/:code/:tab?', element: <ConnectionPage /> }];
